export interface Venue {
  id: string;
  name: string;
  category: string;
  categorySlug: string;
  rating: number;
  reviews: number;
  distanceKm: number;
  image: string;
  address: string;
  district: string;
  isSponsored: boolean;
  isEditorPick: boolean;
  isOpen: boolean;
  description: string;
  badge?: string;
}

export const featuredVenues: Venue[] = [
  {
    id: "extrempark",
    name: "Extrempark Bursa",
    category: "Eğlence",
    categorySlug: "entertainment",
    rating: 4.8,
    reviews: 1820,
    distanceKm: 8.2,
    image: "https://public.readdy.ai/ai/img_res/7c65a7e0dab70e1233e881887e7052b0.jpg",
    address: "Odunluk, Atatürk Kent Ormanı No:17, 16110 Nilüfer/Bursa",
    district: "Nilüfer",
    isSponsored: true,
    isEditorPick: true,
    isOpen: true,
    description: "Türkiye'nin en kapsamlı macera parklarından biri. Dağ kızağı, dev salıncak, ipli parkurlar ve panoramik seyir terası.",
    badge: "Editör Seçimi",
  },
  {
    id: "ulu-cami",
    name: "Ulu Cami",
    category: "Tarihi Yerler",
    categorySlug: "historical",
    rating: 4.9,
    reviews: 3240,
    distanceKm: 1.2,
    image: "https://readdy.ai/api/search-image?query=Ulu%20Cami%20Bursa%20Ottoman%20mosque%20grand%20ancient%20stone%20architecture%20courtyard%20minaret%20historical%20Turkey%20blue%20sky&width=600&height=400&seq=ulucami001&orientation=landscape",
    address: "Atatürk Cad., Osmangazi, Bursa",
    district: "Osmangazi",
    isSponsored: false,
    isEditorPick: true,
    isOpen: true,
    description: "20 kubbesi ve muhteşem içi ile Osmanlı mimarisinin en önemli eserlerinden biri.",
  },
  {
    id: "iskenderoğlu",
    name: "Kebapçı İskender",
    category: "Lezzet Durakları",
    categorySlug: "food",
    rating: 4.8,
    reviews: 4120,
    distanceKm: 0.8,
    image: "https://readdy.ai/api/search-image?query=iskender%20kebab%20Turkish%20food%20traditional%20restaurant%20warm%20tones%20grilled%20meat%20pide%20bread%20tomato%20sauce%20butter%20authentic%20Bursa%20cuisine&width=600&height=400&seq=iskender001&orientation=landscape",
    address: "Atatürk Cad. 60, Osmangazi, Bursa",
    district: "Osmangazi",
    isSponsored: false,
    isEditorPick: true,
    isOpen: true,
    description: "1867'den bu yana aynı tarifte hazırlanan orijinal İskender Kebap. Dünyanın her yerinden misafir ağırlıyor.",
  },
  {
    id: "grand-hotel-gümüşpala",
    name: "Gümüşpala Termal Hotel",
    category: "Konaklama",
    categorySlug: "accommodation",
    rating: 4.7,
    reviews: 892,
    distanceKm: 3.8,
    image: "https://readdy.ai/api/search-image?query=luxury%20thermal%20hotel%20spa%20pool%20Bursa%20Turkey%20elegant%20modern%20architecture%20warm%20stone%20tones%20wellness%20center%20serene%20outdoor%20terrace&width=600&height=400&seq=hotel001&orientation=landscape",
    address: "Çekirge Cad., Osmangazi, Bursa",
    district: "Osmangazi",
    isSponsored: true,
    isEditorPick: false,
    isOpen: true,
    description: "Osmanlı hamamı estetiği ve modern termal spa ile Çekirge'nin en prestijli konaklama adresi.",
    badge: "Sponsorlu",
  },
  {
    id: "cumalikizik",
    name: "Cumalıkızık Köyü",
    category: "Gezilecek Yerler",
    categorySlug: "sightseeing",
    rating: 4.9,
    reviews: 2580,
    distanceKm: 12.0,
    image: "https://readdy.ai/api/search-image?query=Cumalikizik%20village%20Bursa%20Turkey%20traditional%20Ottoman%20stone%20houses%20narrow%20cobblestone%20street%20ancient%20wooden%20buildings%20warm%20morning%20light&width=600&height=400&seq=cumalikizik001&orientation=landscape",
    address: "Cumalıkızık, Yıldırım, Bursa",
    district: "Yıldırım",
    isSponsored: false,
    isEditorPick: true,
    isOpen: true,
    description: "700 yıllık tarihi dokusuyla UNESCO Dünya Mirası listesinde yer alan eşsiz Osmanlı köyü.",
  },
  {
    id: "yesil-turbe",
    name: "Yeşil Türbe & Cami",
    category: "Tarihi Yerler",
    categorySlug: "historical",
    rating: 4.8,
    reviews: 1980,
    distanceKm: 2.1,
    image: "https://readdy.ai/api/search-image?query=Yesil%20Turbe%20Green%20Mausoleum%20Bursa%20Turkey%20ornate%20turquoise%20Ottoman%20tiles%20geometric%20patterns%20ancient%20architecture%20Islamic%20art%20serene&width=600&height=400&seq=yesil001&orientation=landscape",
    address: "Yeşil, Yıldırım, Bursa",
    district: "Yıldırım",
    isSponsored: false,
    isEditorPick: false,
    isOpen: true,
    description: "Osmanlı çini sanatının en nefes kesen örneği. Turkuaz renkli çinileri 6 asırdır aynı güzellikte.",
  },
  {
    id: "teleferik",
    name: "Bursa Teleferik",
    category: "Doğa ve Rotalar",
    categorySlug: "nature",
    rating: 4.7,
    reviews: 1450,
    distanceKm: 8.2,
    image: "https://readdy.ai/api/search-image?query=cable%20car%20gondola%20Uludag%20mountain%20Bursa%20Turkey%20panoramic%20view%20city%20below%20forest%20aerial%20scenic%20ride%20misty%20peaks&width=600&height=400&seq=teleferik001&orientation=landscape",
    address: "Namazgah, Osmangazi, Bursa",
    district: "Osmangazi",
    isSponsored: false,
    isEditorPick: false,
    isOpen: true,
    description: "Dünyanın en uzun teleferik hatlarından biriyle şehirden Uludağ zirvesine panoramik yolculuk.",
  },
  {
    id: "botanik-park",
    name: "Bursa Botanik Parkı",
    category: "Doğa ve Rotalar",
    categorySlug: "nature",
    rating: 4.6,
    reviews: 720,
    distanceKm: 4.5,
    image: "https://readdy.ai/api/search-image?query=botanical%20garden%20park%20Bursa%20Turkey%20lush%20green%20trees%20flowers%20paths%20lake%20serene%20nature%20urban%20park%20families%20walking%20relaxing&width=600&height=400&seq=botanik001&orientation=landscape",
    address: "Çekirge, Osmangazi, Bursa",
    district: "Osmangazi",
    isSponsored: true,
    isEditorPick: false,
    isOpen: true,
    description: "Şehrin merkezinde doğayla iç içe yürüyüş alanları, gölet ve yeşil dinlenme köşeleri.",
    badge: "Sponsorlu",
  },
];

export const nearbyVenues: Venue[] = [
  {
    id: "ulu-cami-nearby",
    name: "Ulu Cami",
    category: "Tarihi Yer",
    categorySlug: "historical",
    rating: 4.9,
    reviews: 3240,
    distanceKm: 1.2,
    image: "https://readdy.ai/api/search-image?query=Ulu%20Cami%20Bursa%20Ottoman%20mosque%20grand%20ancient%20stone%20architecture%20historical%20Turkey%20clear%20sky&width=400&height=300&seq=nearby001&orientation=landscape",
    address: "Atatürk Cad., Osmangazi",
    district: "Osmangazi",
    isSponsored: false,
    isEditorPick: true,
    isOpen: true,
    description: "Osmanlı mimarisinin şaheseri.",
  },
  {
    id: "iskender-nearby",
    name: "Kebapçı İskender",
    category: "Restoran",
    categorySlug: "food",
    rating: 4.8,
    reviews: 4120,
    distanceKm: 0.8,
    image: "https://readdy.ai/api/search-image?query=iskender%20kebab%20authentic%20Turkish%20restaurant%20Bursa%20warm%20light%20interior%20traditional%20setting&width=400&height=300&seq=nearby002&orientation=landscape",
    address: "Atatürk Cad. 60, Osmangazi",
    district: "Osmangazi",
    isSponsored: false,
    isEditorPick: true,
    isOpen: true,
    description: "Orijinal İskender Kebap lezzeti.",
  },
  {
    id: "hotel-nearby",
    name: "Gümüşpala Termal",
    category: "Otel",
    categorySlug: "accommodation",
    rating: 4.7,
    reviews: 892,
    distanceKm: 3.8,
    image: "https://readdy.ai/api/search-image?query=thermal%20hotel%20luxury%20Bursa%20Turkey%20elegant%20warm%20tone%20spa%20wellness%20exterior%20beautiful&width=400&height=300&seq=nearby003&orientation=landscape",
    address: "Çekirge Cad., Osmangazi",
    district: "Osmangazi",
    isSponsored: true,
    isEditorPick: false,
    isOpen: true,
    description: "Termal spa ve modern konfor.",
  },
  {
    id: "yesil-nearby",
    name: "Yeşil Türbe",
    category: "Tarihi Yer",
    categorySlug: "historical",
    rating: 4.8,
    reviews: 1980,
    distanceKm: 2.1,
    image: "https://readdy.ai/api/search-image?query=Green%20Mausoleum%20Yesil%20Turbe%20Bursa%20Ottoman%20tiles%20blue%20turquoise%20ancient%20peaceful&width=400&height=300&seq=nearby004&orientation=landscape",
    address: "Yeşil, Yıldırım",
    district: "Yıldırım",
    isSponsored: false,
    isEditorPick: false,
    isOpen: true,
    description: "Turkuaz çinileriyle büyüleyici türbe.",
  },
];
